/** @jsxImportSource @emotion/react */

import { LoadingOutlined } from "@ant-design/icons";
import { notification, Spin } from "antd";
import { UserApi } from "api/user";
import { ReactComponent as RefreshIcon } from "assets/temporary/icons/refresh.svg";
import avatar from "assets/temporary/images/avatar_default.png";
import { PATH } from "contants/path";
import { ResponseCode } from "contants/response";
import { formatNumberWithCommas } from "helpers/formatNumber";
import { useAppSelector } from "hooks/app-hook";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectUsername } from "store/auth";
import { selectBalance, selectBalanceLoading, selectProfile } from "store/user";
import { getMemberBalance } from "store/user/user.thunk";
import { AppDispatch, StatusNotification } from "types";

import { HeaderAuthStyle } from "./style.index";

interface Props {
  visibleMenu: string;
  colorText: string;
}

interface turnoverType {
  achieve_amount: number;
  current_amount: number;
}

const HeaderAuth = ({ visibleMenu, colorText }: Props) => {
  const { t } = useTranslation(["header", "currency", "placeholder"]);
  const [isLoadingTurnover, setIsLoadingTurnover] = useState<boolean>(false);
  // const [isLoadingBalance, setIsLoadingBalance] = useState<boolean>(false);
  const [amountTurnover, setAmountTurnover] = useState<turnoverType>({
    achieve_amount: 0,
    current_amount: 0,
  });

  const dispatch = useDispatch<AppDispatch>();

  const profileUser = useAppSelector(selectProfile);
  const balanceUser = useAppSelector(selectBalance);
  const isLoading = useAppSelector(selectBalanceLoading);
  const navigate = useNavigate();

  const username = useAppSelector(selectUsername);
  const [api, contextHolder] = notification.useNotification();

  const openNotification = (status: StatusNotification, message: string) => {
    api[status]({
      message,
      description: "",
    });
  };
  const fetchDataTurnover = async () => {
    try {
      setIsLoadingTurnover(true);
      const res = await UserApi.playerTurnover(username);
      setIsLoadingTurnover(false);

      if (res.status === ResponseCode.SUCCESS) {
        setAmountTurnover(res.data);
      }
    } catch (error) {
      throw new Error(error as string);
    }
  };
  const handleRefreshBalance = async () => {
    // setIsLoadingBalance(true);

    try {
      await dispatch(getMemberBalance({ username: username }));

      // setIsLoadingBalance(false);
    } catch (error) {
      openNotification("error", "Please try again later!");
    }
  };

  useEffect(() => {
    fetchDataTurnover();
  }, []);

  return (
    <div css={HeaderAuthStyle.wrapper}>
      <div css={HeaderAuthStyle.infoHeader}>
        <div css={HeaderAuthStyle.groupBalance}>
          <div className="balane">
            <h4 css={HeaderAuthStyle.title(visibleMenu, colorText)}>
              {profileUser && profileUser.username}
            </h4>
            <div css={HeaderAuthStyle.points(visibleMenu, colorText)}>
              <p>
                {t("currency:BDT")}{" "}
                {isLoading ? (
                  <Spin
                    indicator={
                      <LoadingOutlined
                        style={{ fontSize: 12, color: "#298548" }}
                        spin
                      />
                    }
                  />
                ) : (
                  <span>
                    {" "}
                    {formatNumberWithCommas(balanceUser?.total || "0.00")}
                  </span>
                )}
              </p>
            </div>
            <div css={HeaderAuthStyle.points(visibleMenu, colorText)}>
              <p>
                {t("placeholder:Coins")}{" "}
                {isLoading ? (
                  <Spin
                    indicator={
                      <LoadingOutlined
                        style={{ fontSize: 12, color: "#298548" }}
                        spin
                      />
                    }
                  />
                ) : (
                  <span>
                    {" "}
                    {formatNumberWithCommas(balanceUser?.coins || "0.00")}
                  </span>
                )}
              </p>
            </div>
          </div>
          <div className="iconRefresh" onClick={handleRefreshBalance}>
            <RefreshIcon
              className={`${isLoading ? "spin" : ""}`}
              height={16}
              width={16}
            />
          </div>
        </div>
      </div>
      <img
        src={avatar}
        alt=""
        css={HeaderAuthStyle.avatar}
        onClick={() => navigate(PATH.User.TransactionHistory)}
      />
      <div css={HeaderAuthStyle.turnover(visibleMenu, colorText)}>
        <span>{t("placeholder:Turnover")}</span>
        {isLoadingTurnover ? (
          <Spin
            indicator={
              <LoadingOutlined
                style={{ fontSize: 12, color: "#298548" }}
                spin
              />
            }
          />
        ) : (
          <div className="amount">
            <span>
              {formatNumberWithCommas(amountTurnover.current_amount || "0.00")}
            </span>
            <span>&nbsp;/&nbsp;</span>
            <span>
              {formatNumberWithCommas(amountTurnover.achieve_amount || "0.00")}
            </span>
          </div>
        )}
      </div>
      {contextHolder}
    </div>
  );
};

export default HeaderAuth;
